export enum PersonalInfoType {
  Seller = 1,
  Buyer = 2,
}

export type BillOfSalePersonalInfo = {
  firstName: string | null;
  lastName: string | null;
  streetAddress: string | null;
  city: string | null;
  postalCode: string | null;
  province: string | null;
  personalInfoTypeId: PersonalInfoType;
};
